import { useCalculatedDiscount } from 'shared-widget-components/src/hooks/useCalculatedDiscount';
import { WineWidgetModel } from '../../../models/WineWidgetModel';
import { formatEurPrice, formatHufPrice } from 'shared-widget-components/src/utils/FormatPrice';

/**
 * The WineDiscount component renders the price of the wine based on the discount.
 * @returns a JSX fragment. It is rendering the price of the wine. The price is rendered inside a div element with a class name.
 */
export const WineDiscount = ({ wine }: { wine: WineWidgetModel }) => {
  const basePrice = wine.basePrice!;
  const currentPrice = wine.currentPrice!;

  const { calculatedDiscount } = useCalculatedDiscount({ basePrice, currentPrice });

  return (
    <div className={`flex flex-col justify-between ${wine.showEurPrice ? 'min-[350px]:mt-[4px] md:mt-[12px] h-[53px]' : 'min-[350px]:mt-0 md:mt-0 h-[34px]'}`}>
      <div className='flex h-[19px]'>
        <h1 className={`font-normal min-[350px]:text-[16px] sm:text-[18px] mr-[8px] font-body ${calculatedDiscount > 0 ? 'text-[#C01010]' : 'text-black'} `}>
          {calculatedDiscount > 0 ? wine.currentPrice && formatHufPrice(wine.currentPrice) : wine.basePrice && formatHufPrice(wine.basePrice)}
        </h1>
        {/** no discount, only eur and huf price */}
        {calculatedDiscount === 0 && wine.baseEurPrice && wine.showEurPrice && (
          <h1 className='font-normal  ml-[4px]  text-black min-[350px]:text-[16px] sm:text-[18px] font-body'>({formatEurPrice(wine.baseEurPrice)})</h1>
        )}

        {/** discount, but no eur price */}
        {calculatedDiscount > 0 && wine.basePrice && <h1 className='font-normal ml-[4px] text-black min-[350px]:text-[16px] sm:text-[18px] font-body line-through opacity-40'>{formatHufPrice(wine.basePrice)}</h1>}
      </div>
      {wine.showEurPrice && (
        <div className='flex h-[19px]'>
          {/** eur current price if there is a discount */}
          {calculatedDiscount > 0 && wine.currentEurPrice && wine.showEurPrice && (
            <h1 className={`font-normal  min-[350px]:text-[14px] sm:text-[16px] mr-[8px] text-[#C01010] font-body`}>({formatEurPrice(wine.currentEurPrice)}</h1>
          )}
          {/** eur base price if there is a discount */}
          {calculatedDiscount > 0 && wine.baseEurPrice && wine.showEurPrice && (
            <h1 className='text-black  font-normal min-[350px]:text-[14px] sm:text-[16px] font-body line-through opacity-40'>{formatEurPrice(wine.baseEurPrice)})</h1>
          )}
        </div>
      )}
    </div>
  );
};
